// LICENSE_CODE ZON
'use strict';/*jslint ts:true, react: true*/
import React, {CSSProperties} from 'react';
import {oculus_img_url} from '../../../../hola/pub/ui/oculus_img_url';

const get_flag_country_code = (country_code: string): string=>{
    const other_country_territories = {
        'gp': 'fr', // Guadeloupe
        'gf': 'fr', // French Guiana
        'mf': 'fr', // Saint Martin
        'bl': 'fr', // Saint Barthelemy
        're': 'fr', // Réunion
        'yt': 'fr', // Mayotte
        'wf': 'fr', // Wallis And Futuna Islands
        'nc': 'fr', // New Caledonia
        'pm': 'fr', // Saint Pierre and Miquelon
        'tf': 'fr', // French Southern and Antarctic Lands
        'um': 'us', // United States Minor Outlying Islands
        'bv': 'no', // Bouvet Island
        'sj': 'no', // Svalbard and Jan Mayen
        'hm': 'au', // Heard Island and McDonald Islands
        'an': 'nl', // Netherlands Antilles
    };
    const code = country_code?.toLowerCase();
    return other_country_territories[code] || code;
  };

interface i_flag_props {
    country: string;
    cls?: string;
    size?: number;
    on_click?: ()=>void;
    style?: CSSProperties;
}

export const Flag = (props: i_flag_props)=>{
    const {country, cls, size = 48, on_click, style} = props;
    const flag_code = get_flag_country_code(country);
    return <img className={cls} width={size} height={size} onClick={on_click}
      style={style} src={oculus_img_url(`flags/${flag_code}.svg`)}/>;
};
